export default __webpack_public_path__ + "static/media/header-burger.4baa6e00.svg";